import React, { useEffect, useState, useCallback } from 'react';
import { CalendarRange } from 'lucide-react';
import { useT } from '../../i18n/LanguageContext';
import { schoolApi } from '../../api/school';
import { PageHeader, EmptyState, LoadingState, Card } from '../../components/school/ui';
import { Badge } from '../../components/ui/badge';
import TimetableReadOnly from '../../components/school/timetable/TimetableReadOnly';
import { toast } from 'sonner';

export default function TeacherMyTimetablePage() {
  const { t } = useT();
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [noProfile, setNoProfile] = useState(false);

  const init = useCallback(async () => {
    try {
      setLoading(true);
      setNoProfile(false);
      setData(await schoolApi.myTeacherTimetable());
    } catch (e) {
      if (e?.response?.status === 404) setNoProfile(true);
      else toast.error(e?.response?.data?.detail || 'Failed to load timetable');
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { init(); }, [init]);

  const yearName = data?.academic_year?.name;

  return (
    <div className="max-w-[1400px] mx-auto">
      <PageHeader
        title={t('portal.myTimetable', 'My Timetable')}
        subtitle={data?.title}
        icon={CalendarRange}
        actions={yearName ? <Badge variant="outline" data-testid="tt-year-badge">{yearName}</Badge> : null}
      />

      {loading ? (
        <LoadingState rows={6} />
      ) : noProfile ? (
        <Card><EmptyState icon={CalendarRange} title={t('portal.noProfile')} /></Card>
      ) : (data?.entries?.length || 0) === 0 ? (
        <Card>
          <EmptyState
            icon={CalendarRange}
            title={t('portal.noTimetable', 'No timetable yet')}
            description={t('portal.noTimetableHint', 'Your schedule for this academic year has not been published yet.')}
          />
        </Card>
      ) : (
        <TimetableReadOnly config={data.config} entries={data.entries} mode="teacher" />
      )}
    </div>
  );
}
